import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from 'gossamer-front-end';
import { BookingList } from './WebsiteAccountLists';

export const WebsiteAccountCancelledBookingsPage = (): React.JSX.Element => {
  const user = useSelector(selectUser);
  return (
    <BookingList
      query={{
        where: {
          and: [
            { fieldId: 'user_id', operator: 'eq', value: user?.userId || '' },
            { fieldId: 'booking_status', operator: 'eq', value: 'canx-booking' },
          ],
        },
        order: [['start_at', 'DESC']],
        offset: 0,
        limit: 50,
      }}
      emptyText="No cancelled bookings."
    />
  );
};
